module.exports = __webpack_public_path__ + "img/active-16.1e6ddb8c.svg";